
type Result<T, E> = {data?: T; error?: E; loading: boolean}
export function isQueryLoaded<R, E, T extends Result<R, E>>(
  options: T,
): options is T & { data: Exclude<T['data'], undefined>; error?: undefined; loading: false} {
  return !!options.data && !options.loading && !options.error
}
